var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{attrs:{"id":"breadcrumb"}},[_c('v-breadcrumbs-item',{attrs:{"to":"/mailings"}},[_c('v-icon',[_vm._v("mdi-mail")])],1),_vm._l((_vm.breadcrumbs),function(breadcrumb,idx){return _c('v-breadcrumbs-item',{key:idx,attrs:{"to":breadcrumb.href,"disabled":breadcrumb.disabled}},[_vm._v(_vm._s(breadcrumb.text))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }